import { escapeRegExp, orderBy } from "lodash";
import { useMemo } from "react";
import { SortOrderMap, SortValueGetterMap } from "./constant";
import { Fan, FansSorting } from "./models";

export function useFansList(fans: Fan[], sortFansBy: FansSorting, searchValue: string) {

  const fansList = useMemo(() => {
    if (!fans) return [];

    let filteredFans = orderBy(
        [...fans],
        [SortValueGetterMap[sortFansBy]],
        [SortOrderMap[sortFansBy]]
      );
    if (searchValue) {
      const pattern = new RegExp(escapeRegExp(searchValue), "i");

      filteredFans = fans.filter(fan =>
        pattern.test(fan.fullName as string) ||
        pattern.test(fan.email as string) ||
        pattern.test(fan.phone as string)
      );
    }

    return filteredFans;
  }, [sortFansBy, searchValue, fans]);

  return fansList;
}
